import { Phone } from 'lucide-react';
import { Button } from './ui/button';

const StickyCallButton = () => {
  return (
    <a
      href="tel:+918310755854"
      className="fixed bottom-6 right-6 z-40 lg:hidden"
    >
      <Button
        size="lg"
        className="bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg rounded-full w-16 h-16 p-0 animate-pulse"
      >
        <Phone className="h-6 w-6" />
      </Button>
    </a>
  );
};

export default StickyCallButton;